<script lang="ts">
  import { page } from '$app/stores';
  import Alert from '$lib/components/Alert.svelte';
  import { session } from '$lib/stores';
  import { writable } from 'svelte/store';
  import Footer from './Footer.svelte';
  import type { LayoutData } from './$types';
  import EmailVerificationAlert from '$lib/components/EmailVerificationAlert.svelte';
  import type { users_role } from '@prisma/client';

  export let data: LayoutData;

  const status = writable<'loading' | 'error' | 'success' | null>(null);
  const showMenu = writable<boolean>(false);
  const ADMIN_SCOPE: (users_role | null)[] = ['admin', 'moderator'];

  const toggleMenu = () => ($showMenu = !$showMenu);
</script>

<div class="relative bg-slate-900 flex justify-center z-10">
  <div class="w-full">
    <nav class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="h-16 flex items-center justify-between">
        <div class="flex-1 flex lg:items-center">
          <a href="/">
            <span class="sr-only">Subastasfral</span>
            <img src="/assets/fral-logo.svg" alt="Subastas FRAL" class="h-10" />
          </a>
        </div>

        <div class="px-4 bottom-0 inset-x-0 h-full">
          <div class="hidden justify-center lg:flex lg:h-full">
            <a
              href="/"
              class={`flex items-center text-sm font-medium text-white px-4 ${
                $page.url.pathname == '/' ? 'bg-primary-500' : ''
              }`}
            >
              Portada
            </a>
            {#if data.hasFeaturedAuctions}
              <a
                href="/subastas"
                class={`flex items-center text-sm font-medium text-white px-4 ${
                  $page.url.pathname == '/subastas' ? 'bg-primary-500' : ''
                }`}
              >
                Destacados
              </a>
            {/if}
            {#if data.hasRealEstate}
              <a
                href="/inmuebles"
                class={`flex items-center text-sm font-medium text-white px-4 ${
                  $page.url.pathname == '/inmuebles' ? 'bg-primary-500' : ''
                }`}
              >
                Inmuebles
              </a>
            {/if}
            <a
              href="/contacto"
              class={`flex items-center text-sm font-medium text-white px-4 ${
                $page.url.pathname == '/contacto' ? 'bg-primary-500' : ''
              }`}
            >
              Contacto
            </a>
          </div>
        </div>

        <div class="flex lg:hidden h-full">
          <button
            type="button"
            class="inline-flex items-center justify-center rounded-md p-2.5 text-white"
            on:click={toggleMenu}
          >
            <span class="sr-only">Menu</span>
            <svg
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
        </div>
      </div>
    </nav>
    <div class={$showMenu ? 'flex' : 'hidden'} role="dialog" aria-modal="true">
      <!-- Background backdrop, show/hide based on slide-over state. -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div class="fixed inset-0 z-50" on:click={toggleMenu} on:keypress={() => {}} />
      <div
        class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-slate-900 px-4 py-5 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      >
        <div class="flex items-center justify-between">
          <a href="/" class="pt-6" on:click={toggleMenu}>
            <span class="sr-only">Subastasfral</span>
            <img src="/assets/fral-logo.svg" alt="Subastas FRAL" class="h-10" />
          </a>
          <button type="button" class="-m-2.5 rounded-md p-2.5 text-white" on:click={toggleMenu}>
            <span class="sr-only">Cerrar menu</span>
            <svg
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-500/10">
            <div class="space-y-2 py-6">
              <a
                href="/"
                on:click={toggleMenu}
                class={`-mx-3 rounded-lg px-3 py-2 leading-7 flex items-center text-base font-semibold text-white ${
                  $page.url.pathname == '/' ? 'bg-primary-500' : ''
                }`}
              >
                Portada
              </a>
              {#if data.hasFeaturedAuctions}
                <a
                  href="/subastas"
                  on:click={toggleMenu}
                  class={`-mx-3 rounded-lg px-3 py-2 leading-7 flex items-center text-base font-semibold text-white ${
                    $page.url.pathname == '/subastas' ? 'bg-primary-500' : ''
                  }`}
                >
                  Destacados
                </a>
              {/if}
              <a
                href="/contacto"
                on:click={toggleMenu}
                class={`-mx-3 rounded-lg px-3 py-2 leading-7 flex items-center text-base font-semibold text-white ${
                  $page.url.pathname == '/contacto' ? 'bg-primary-500' : ''
                }`}
              >
                Contacto
              </a>
            </div>
          </div>
        </div>
        {#if $session}
          <div class="space-y-2 py-6 text-white flex flex-col border-t border-white">
            {#if ADMIN_SCOPE.includes($session.role ?? 'user')}
              <a
                href="/reportes"
                on:click={toggleMenu}
                class={`-mx-3 rounded-lg px-3 py-2 leading-7 flex items-center text-base font-semibold text-white ${
                  $page.url.pathname == '/reportes' ? 'bg-primary-500' : ''
                }`}
              >
                <svg
                  class="flex-shrink-0 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                  />
                </svg>
                <span class="ml-2">Reportes</span>
                <span class="sr-only">reportes</span>
              </a>
            {/if}
            <a
              href="/mis-lotes"
              on:click={toggleMenu}
              class={`-mx-3 rounded-lg px-3 py-2 leading-7 flex items-center text-base font-semibold text-white ${
                $page.url.pathname == '/mis-lotes' ? 'bg-primary-500' : ''
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="flex-shrink-0 h-5 w-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                />
              </svg>
              <span class="ml-2">Mis lotes</span>
              <span class="sr-only">mis lotes</span>
            </a>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

{#if $session && !$session.email_verified_at}
  <div class="flex justify-center">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {#if $status == 'error'}
        <Alert severity="danger">
          <p>Ha ocurrido un error al enviar el correo de verificación.</p>
        </Alert>
      {:else if $status == 'success'}
        <Alert severity="success">
          <p>Se ha enviado un correo de verificación.</p>
        </Alert>
      {:else}
        <EmailVerificationAlert />
      {/if}
    </div>
  </div>
{/if}

<slot />

<Footer />
